module.exports = __webpack_public_path__ + "a974bf6a388255f29d0a838acb69b47d.png";